import { render } from "./dataTable2.vue?vue&type=template&id=75ecc193"
import script from "./dataTable2.vue?vue&type=script&lang=js"
export * from "./dataTable2.vue?vue&type=script&lang=js"

import "./dataTable2.vue?vue&type=style&index=0&id=75ecc193&lang=css"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__